/**
 * @namespace
 */

let team = {};


/**
 *获取项目列表
 *
 * @param {Object} params
 * @param params.team_id  团队ID
 * @returns {Object}
 */

team.getTeams = async function(){
    let url = '/account/user_teams'
    try{
        let res = await axios.get(url);
        return res.data?res.data:res;
    }catch(err){
        console.log(err);
    }
    
    return null;

}


export default team;